import { createTheme } from "@mui/material";

export const palette = {
  primary: {
    main: "#0583b8",
  },
  background: {
    default: "#dfefee",
  },
  text: { primary: "#333333" },
};

const theme = createTheme({
  palette,
  breakpoints: { values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 } },
});

export default theme;
